module.exports = require('@abyss/core/next-app');